import React from 'react';
import styles from './styles';
import { ClassNameMap, withStyles } from '@mui/styles';
const IssuesDataGridView = React.lazy(
  () => import('./IssuesDataGridView').then((m) => ({ default: m.IssuesDataGridView }))
);

interface Props {
  classes: ClassNameMap;
}

const Presentational: React.FC<Props> = ({ classes }) => {
  return (
    <div className={classes.issueTableWrapper}>
      <React.Suspense fallback={null}>
        <IssuesDataGridView />
      </React.Suspense>
    </div>
  );
};

export default withStyles(styles)(Presentational);
